<template>
  <div class="loading">
      <img src="/fstatic/spinner.svg" alt="">
  </div>  
</template>

<script>
export default {
  props: {
    isLoading: {
      default: true,
      type: Boolean,
    }
  },
  created() {
    if (this.isLoading) {
      document.getElementsByTagName('body')[0].classList.add('no-overflow');
    }
  },
  destroyed() {
    document.getElementsByTagName('body')[0].classList.remove('no-overflow');
  }
}
</script>

<style scoped lang="scss">
  .loading {
    height: 100vh;
    top: 0px;
    width: 100%;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    overflow: hidden;
    background: rgba(0,0,0,.5);
    img {
    animation: rotate 1.8s infinite linear;
      width: 20%;
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(0Deg);
    }
    100% {
      transform: rotate(359Deg);
    }
  }
</style>



// WEBPACK FOOTER //
// Loading.vue?e32d4040